import { render, staticRenderFns } from "./branddetails.vue?vue&type=template&id=66a0704f&scoped=true&"
import script from "./branddetails.vue?vue&type=script&lang=js&"
export * from "./branddetails.vue?vue&type=script&lang=js&"
import style0 from "./branddetails.vue?vue&type=style&index=0&id=66a0704f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a0704f",
  null
  
)

export default component.exports